exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-area[data-v-a38cb2dc] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 10px 0 20px;\n}\n.pagination-wrap[data-v-a38cb2dc] {\n  text-align: right;\n  margin-top: 15px;\n}\n", ""]);

// exports
